module.exports = __webpack_public_path__ + "static/media/facebook-icon-2.988b7862.svg";